import axiosVApi from '../axiovishwam';

export async function GetWorkFlowForApprovalForAsset(request) {
    try {
        const response = await axiosVApi.post(`/WorkFlow/GetWorkFlow`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error GetWorkFlowForApprovalForAsset===>:", error);
        return error?.response?.data?.data;
    }
};